import React from 'react';

function Navigation() {
    return (
        <>
            <ul>
                <li>
                    <a href="#">
                        Download <i className="fal fa-angle-down" />
                    </a>
                    <ul className="sub-menu">
                        <li>
                            <a
                                rel="noreferrer"
                                href="https://play.google.com/store/apps/details?id=com.axiel7.moelist"
                                target="_blank"
                            >
                                From Play Store
                            </a>
                        </li>
                        <li>
                            <a
                                rel="noreferrer"
                                href="https://apt.izzysoft.de/fdroid/index/apk/com.axiel7.moelist"
                                target="_blank"
                            >
                                From F-Droid
                            </a>
                        </li>
                        <li>
                            <a
                                rel="noreferrer"
                                href="https://github.com/axiel7/MoeList/releases/latest"
                                target="_blank"
                            >
                                From GitHub
                            </a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#">
                        Support <i className="fal fa-angle-down" />
                    </a>
                    <ul className="sub-menu">
                        <li>
                            <a
                                rel="noreferrer"
                                href="https://discord.gg/CTv3WdfxHh"
                                target="_blank"
                            >
                                Discord
                            </a>
                        </li>
                        <li>
                            <a href="mailto://contacto.axiel7@gmail.com">E-Mail</a>
                        </li>
                        <li>
                            <a href="mailto://support@lunoxia.de">Website related</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a rel="noreferrer" href="https://crowdin.com/project/moelist" target="_blank">
                        Crowdin
                    </a>
                </li>
                <li>
                    <a rel="noreferrer" href="https://github.com/axiel7/MoeList" target="_blank">
                        Github
                    </a>
                </li>
                <li>
                    <a rel="noreferrer" href="https://axiel7.github.io" target="_blank">
                        Creator
                    </a>
                </li>
            </ul>
        </>
    );
}

export default Navigation;
